import React from "react";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import FastRewindIcon from "@material-ui/icons/FastRewind";
import PauseIcon from "@material-ui/icons/Pause";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import FastForwardIcon from "@material-ui/icons/FastForward";
import Typography from "@material-ui/core/Typography";
import GranpopsUke from "./songs/Grandpop's Uke.mp3"
import HandOfGod from "./songs/Hand Of God (Outro).mp3"
import Luxury from "./songs/Luxury.mp3"
import Butterfiles from "./songs/samsa - butterflies.mp3"
import FlyYouToTheMoon from './songs/Mike Stud - Fly You To The Moon.mp3'
import RhymesLikeDimes from './songs/MF DOOM - Rhymes Like Dimes [HD].mp3'
import Cataclysm from './songs/cataclysm.mp3'
import FeelsLikeSummer from './songs/Childish Gambino - Feels Like Summer (1).mp3'
import Woodstock from './songs/Jon Bellion - Woodstock (Psychedelic Fiction).mp3'
import LessThanIDo from './songs/Less Than I Do.mp3'
import MaybeIDK from './songs/Maybe IDK.mp3'
import Bohemian from './songs/Queen Bohemian Rhapsody (Official Video Remastered).mp3'
import SenAller from "./songs/Swing - S'en aller feat. Angèle (lyrics video).mp3"
import StillAlive from './songs/A R I Z O N A - Still Alive [Official Audio].mp3'
import Sexy from './songs/LMFAO - Sexy and I Know It (Official Video).mp3'
import Alien from './songs/Oliver Tree - Alien Boy [Lyric Video].mp3'
import Tadow from './songs/Masego + FKJ - Tadow.mp3'
import MeAndYourMama from './songs/Childish Gambino - Me and Your Mama (Official Audio) (128 kbps).mp3'
import Funeral from './songs/Mac Miller - Funeral.mp3'
import Charcoal from './songs/charcoal.mp3'
import MarryMe from './songs/Alvvays - Archie, Marry Me (Official Video).mp3'
import SeeYouAgain from './songs/Tyler, The Creator - See You Again.mp3'
import IDontLoveYou from "./songs/I DON'T LOVE YOU ANYMORE.mp3"
import TheGates from './songs/The Gates.mp3'
import TwinSizeMattress from './songs/The Front Bottoms - Twin Size Mattress (Official).mp3'
import IDontKnowYou from "./songs/The Marías - I Don't Know You.mp3"
import Attention from "./songs/Joji - ATTENTION A COLORS SHOW.mp3"
import AcidRain from './songs/Chance The Rapper - Acid Rain.mp3'
import Yellow from './songs/Aminé - Yellow A COLORS SHOW.mp3'
import Boredom from './songs/Tyler, the Creator - Boredom [feat. Anna of the North, Corinne Bailey & Rex Orange County].mp3'
import Sunflower from './songs/Rex Orange County - Sunflower.mp3'
import DaphneBlue from './songs/The Band CAMINO - Daphne Blue (Official Lyric Video).mp3'
import Curls from './songs/Madvillain - Curls - Madvillainy (Full Album).mp3'
import Weekend from './songs/Mac Miller - Weekend (feat. Miguel) [Lyrics].mp3'
import Nostalgic from './songs/A R I Z O N A - Nostalgic [Official Music Video].mp3'
import Bagels from './songs/Bagels.mp3'
import Colorado from './songs/KOTA The Friend - COLORADO.mp3'
import HeLovesMe from './songs/Brittany Howard - He Loves Me (Official Audio).mp3'
import Israel from './songs/Chance The Rapper - Israel ft. Noname Gypsy.mp3'
import TwentyThree from './songs/23.mp3'
import LovingIsEasy from './songs/Rex Orange County - Loving is Easy (feat. Benny Sings) [Official Video].mp3'


import {useAudio} from 'react-use'
import FadeLoader from 'react-spinners/FadeLoader'

export const MP3Player = (props) => {


    let songs = React.useMemo(() => {
        return [
            {name: 'Jon Bellion - Hand of God', song: HandOfGod},
            {name: 'Childish Gambino - Feels Like Summer', song: FeelsLikeSummer},
            {name: "The Band CAMINO - Less Than I Do", song: LessThanIDo},
            {name: 'Samsa - Charcoal', song: Charcoal},
            {name: "Aminé - Yellow", song: Yellow},
            {name: 'Jon Bellion - Woodstock', song: Woodstock},
            {name: 'Childish Gambino - Me and Your Mama', song: MeAndYourMama},
            {name: 'Jon Bellion - Luxury', song: Luxury},
            {name: 'KOTA The Friend - Bagels', song: Bagels},
            {name: "Brittany Howard - He Loves Me", song: HeLovesMe},
            {name: 'Queen - Bohemian Rhapsody', song: Bohemian},
            {name: "Swing - S'en aller feat. Angele", song: SenAller},
            {name: 'A R I Z O N A - Still Alive', song: StillAlive},
            {name: 'Tyler, The Creator - See You Again', song: SeeYouAgain},
            {name: 'Oliver Tree - Alien Boy', song: Alien},
            {name: "Jon Bellion - Maybe IDK", song: MaybeIDK},
            {name: 'Masego + FKJ - Tadow', song: Tadow},
            {name: 'A R I Z O N A - Nostalgic', song: Nostalgic},
            {name: "Forrest - Grandpop's Uke", song: GranpopsUke},
            {name: "MF DOOM - Rhymes Like Dimes", song: RhymesLikeDimes},
            {name: 'Samsa - Cactaclysm', song: Cataclysm},
            {name: 'Mac Miller - Funeral', song: Funeral},
            {name: "Mike Stud - Fly You To The Moon", song: FlyYouToTheMoon},
            {name: 'Samsa - Butterflies', song: Butterfiles},
            {name: "KOTA The Friend - Colorado", song: Colorado},
            {name: 'Alvvays - Archie, Marry Me', song: MarryMe},
            {name: 'LMFAO - Sexy and I Know It', song: Sexy},
            {name: 'Chance The Rapper - Israel ft. Noname Gypsy', song: Israel},
            {name: "Rex Orange County - Loving is Easy" , song: LovingIsEasy},
            {name: "Tyler, The Creator - I DON'T LOVE YOU ANYMORE" , song: IDontLoveYou},
            {name: "Aesop Rock - The Gates" , song: TheGates},
            {name: "The Front Bottoms - Twin Size Mattress" , song: TwinSizeMattress},
            {name: "The Marías - I Don't Know You" , song: IDontKnowYou},
            {name: "Joji - ATTENTION" , song: Attention},
            {name: "Chance The Rapper - Acid Rain" , song: AcidRain},
            {name: "Tyler, The Creator - Boredom" , song: Boredom},
            {name: "Mac Miller - Weekend", song: Weekend},
            {name: "Rex Orange County - Sunflower" , song: Sunflower},
            {name: "The Band CAMINO - Daphne Blue" , song: DaphneBlue},
            {name: "MF DOOM - Curls" , song: Curls},
            {name: "23 (Happy Burfday)", song: TwentyThree}

        ]
    },[])

    const [song, setSong] = React.useState(0)
    const [prevSong, setPrevSong] = React.useState(0)
    const [prevTime, setPrevTime] = React.useState(0)
    // React.useEffect(() => {
    //     if (props.showCard) {
    //         setPrevSong(song)
    //         setPrevTime(state.time)
    //         setSong(songs.length - 1)
    //     }
    //     else {
    //         setSong(prevSong)
    //         controls.seek(prevTime)
    //     }
    // },[props.showCard])

    const [audio, state, controls] = useAudio({
        src: songs[song] && songs[song].song ? songs[song].song:null,
        autoPlay: true,
    })

    // React.useEffect(() => {
    //     if (state.time.toFixed(3) >= state.duration.toFixed(3)) {
    //         handleForward()
    //     }
    // },[state.time, state.duration])
    const handleForward = e => {
        if (song !== songs.length -1) {
            setSong(song + 1)
        }
        else setSong(0)
    }

    const handleBackward = e => {
        if (song !== 0) {
            setSong(song - 1)
        }
        else setSong(songs.length - 1)
    }

    return (
        <div className={'mp3Player'}>
            {audio}
            <Grid container item xs={12} spacing={0} style={{border: '3px solid white', marginBottom: 10, borderRadius: 15}}>
                <Grid item xs={4}  style={{zIndex: 39}}>
                    <IconButton color={'inherit'} style={{color:'white'}} onClick={handleBackward}>
                        <FastRewindIcon/>
                    </IconButton>
                </Grid>
                <Grid item xs={4}  style={{zIndex: 39}}>
                    <IconButton onClick={() => {
                        state.paused ? controls.play():controls.pause()
                    }}
                    color={'inherit'}
                     style={{color:'white'}} >
                        {state.paused ? <PlayArrowIcon/>:<PauseIcon/>}
                    </IconButton>
                </Grid>
                <Grid item xs={4}  style={{zIndex: 39}}>
                    <IconButton color={'inherit'} style={{color:'white'}} onClick={handleForward}>
                        <FastForwardIcon/>
                    </IconButton>
                </Grid>
            </Grid>
            <Typography align={'center'} color={'inherit'}  style={{fontFamily: "'Josefin Sans', sans-serif", color: 'white'}}>
                {state.paused && state.time === 0 ? 'Press Play!': songs[song].name}
            </Typography>


            {state.paused === false && state.time && state.time < 0.2 &&
            <div className={'loader'}>
                <FadeLoader loading={true} color={'white'} size={80}/>
            </div>}
        </div>
    )

}
